import React, { useEffect,lazy,Suspense } from 'react'
import Navbar from './Components/Navbar/Navbar'
import Home from './Components/Home/Home';
import Aos from "aos"
import "aos/dist/aos.css"

const Footer= lazy(()=>import('./Components/Footer/Footer'))
import Enquiry from './Components/Enquiry/Enquiry'
import {BrowserRouter as Router,Routes,Route,useLocation} from "react-router-dom";
import Gallery from './Components/Gallery/Gallery'
import Contactus from './Components/Contactus/Contactus'
import Scrollontop from './Components/Scrollontop/Scrollontop'
import Project from './Components/Project/Project'
import Mechanicalprojects from './Components/Project/Mechanicalprojects'
import Ece from './Components/Project/Ece'
import Eee from './Components/Project/Eee'
import Civil from './Components/Project/Civil'
import Web from './Components/Project/Web'



const App = () => {

  //location 

  const location= useLocation();
  
  const container={
    paddingTop:location.pathname === "/" ? "150px" :"0px"
  }
  
  useEffect(()=>{
      Aos.init({
        duration:1000
      });
  },[])
  return (
    <div>
      
       {/* nav at top */}
       <Navbar/>
       
          <Scrollontop/>
          <div style={container}>
          <Suspense fallback={<div>Loading...</div>}>
          <Routes>
          
          <Route path="/"          element={<Home/>}/>
          <Route path="/enquiries" element={<Enquiry/>}/>
         
          <Route path="/projects"      element={<Project/>}/>
          <Route path="/projects/mechanicalprojects" element={<Mechanicalprojects/>}/>
          <Route path="/projects/ece"  element={<Ece/>}/>
          <Route path="/projects/eee"  element={<Eee/>}/>
          <Route path='/projects/civil' element={<Civil/>}/>
          <Route path="/projects/web"   element={<Web/>}/>
         
          <Route path="/gallery"   element={<Gallery/>}/>
          <Route path="/contactus" element={<Contactus/>}/>
         </Routes>
         </Suspense>
       </div>
        
      
         {/* footer at bottom */}
         {!["/projects/mechanicalprojects","/projects/ece","/projects/eee","/projects/civil"].includes(location.pathname) && <Footer/>}
       
    </div>
  )
}

export default App